import { jsxs as t, jsx as n } from "react/jsx-runtime";
import e from "../../../node_modules/prop-types/index.es.js";
import { useState as x } from "react";
import * as T from "./style.es.js";
import { EdidatableForm as A, EndButtons as j, EdidatableFormActions as B, EditableFormEditAction as I } from "./style.es.js";
import { IconButton as s } from "../Button/IconButton.es.js";
import { Icon as a } from "../../DataDisplay/Icon/Icon.es.js";
function c({
  children: b,
  editable: h,
  editButtonText: d,
  editInput: m,
  endButton: f = null,
  isSaveDisabled: E = !1,
  onClick: y,
  onEditCancel: p,
  onEditClick: u,
  onSave: r,
  value: g
}) {
  const [i, l] = x(!1), F = (o) => {
    o.stopPropagation(), u ? u(o) : l(!0);
  }, C = (o) => {
    o.stopPropagation(), p && p(), l(!1);
  }, P = (o) => {
    o.stopPropagation(), r == null || r(), l(!1);
  }, k = () => i ? /* @__PURE__ */ t(B, { children: [
    /* @__PURE__ */ n(s, { onClick: C, color: "secondary", rounded: !1, children: /* @__PURE__ */ n(a, { name: "close" }) }),
    /* @__PURE__ */ n(s, { onClick: P, disabled: E, color: "secondary", rounded: !1, children: /* @__PURE__ */ n(a, { name: "success" }) })
  ] }) : /* @__PURE__ */ t(I, { onClick: F, children: [
    /* @__PURE__ */ n(s, { variant: "text", children: /* @__PURE__ */ n(a, { name: "edit" }) }),
    d && d
  ] });
  return /* @__PURE__ */ t(A, { onClick: y, children: [
    i && m && m(),
    !i && (b || g),
    /* @__PURE__ */ t(j, { children: [
      h && k(),
      f && f
    ] })
  ] });
}
const v = {
  children: e.oneOfType([e.element, e.string]),
  editable: e.bool,
  editButtonText: e.string,
  editInput: e.func,
  endButton: e.element,
  isSaveDisabled: e.bool,
  onClick: e.func,
  onEditCancel: e.func,
  onEditClick: e.func,
  onSave: e.func,
  value: e.string
};
c.displayName = "EditableForm";
c.S = T;
c.propTypes = v;
export {
  c as EditableForm,
  v as editableFormPropTypes
};
//# sourceMappingURL=EdidatableForm.es.js.map
